import React from 'react';
import { useImageSrc } from '../hooks/useImageSrc.js';
import styles from '../../common/ImageUploader/ImageUploader.module.scss';

function ImageAttachment({ path, width = null, previewBackground = false, ...rest }) {
  const src = useImageSrc({path});
  const ImageComponent = <img src={src} alt="" style={{width: width, height: previewBackground ? '90%' : 'auto'}} {...rest} />
  if (!previewBackground) {
    return ImageComponent;
  }
  return <div className={styles['preview-background']}>{ImageComponent}</div>
}

export default ImageAttachment;